module.exports = __webpack_public_path__ + "static/success-page-level-example-9bc4bc70f8b99dfbef7b1c752f9d9a44.svg";